module.exports = __webpack_public_path__ + "img/PEC9000_R.58749fe7.png";